jQuery(document).ready(function($) {

	const $body = $('body');
	const $window = $(window);
	const $document = $(document);

	smoothScroll($);
	hamburgerToggle($, $body);
	pageIsScrolled($, $body, $window, $document);
	subscribeToNewsletter($);
	videoControls($);
	

	AOS.init({
		offset: 100,
		duration: 1000
	});

});

jQuery(window).on("load", function(e) {

	jQuery("[rel=preload]").attr('rel', 'stylesheet');


	jQuery("body").removeClass("preload");

});

var ignore_onbeforeunload = false;

jQuery('a[href^=mailto]').on('click',function(){
	ignore_onbeforeunload = true;
});


jQuery(window).on('beforeunload', function(){
	if (!ignore_onbeforeunload){
		jQuery("body").addClass("preload");
	}
	ignore_onbeforeunload = false;
});


function videoControls($) {

	const $videoContainers = $('.js-video-container');
	if (!$videoContainers.length) return;

	$videoContainers.each( function() {

		const $videoContainer = $(this);
		const $video = $videoContainer.find('.js-video');
		const videoDomElem = $video.get(0);
		const $playButton = $videoContainer.find('.js-play');
		const $fullscreenButton = $videoContainer.find('.js-fullscreen');
	
		$video.on( 'playing', function() { 
			$videoContainers.addClass('playing');
		});
		$video.on( 'pause', function() { 
			$videoContainers.removeClass('playing');
		});
		$playButton.on( 'click', function() { playVideo($video, $playButton) });
		$fullscreenButton.on( 'click', function() { fullscreenVideo(videoDomElem) } );

	});

	function playVideo($video, $playButton) {

		if ( $video.prop('paused') ) {
			$video.trigger('play');
			$playButton.removeClass('icon-play');
			$playButton.addClass('icon-pause');
		}
		else {
			$video.trigger('pause');
			$playButton.removeClass('icon-pause');
			$playButton.addClass('icon-play');
		}
  
	}
  
	function fullscreenVideo(videoDomElem) {
		if (videoDomElem.requestFullscreen) {
			videoDomElem.requestFullscreen();
		} else if (videoDomElem.mozRequestFullScreen) { /* Firefox */
			videoDomElem.mozRequestFullScreen();
		} else if (videoDomElem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
			videoDomElem.webkitRequestFullscreen();
		} else if (videoDomElem.msRequestFullscreen) { /* IE/Edge */
			videoDomElem.msRequestFullscreen();
		}
	}
  
  
}


function pageIsScrolled($, $body, $window, $document) {

	scrollClasses();
 
	$window.on( 'scroll', function() {
		scrollClasses();
	});

	function scrollClasses() {		
		var $spacer = µSpacer(2.5);
		$body.toggleClass('scrolled', $document.scrollTop() > $spacer);		
	}

}

function hamburgerToggle($, $body) {

	const $hamburgerIcon = $('.hamburger-toggle');
	$hamburgerIcon.on("click", function(e) {
		$body.toggleClass('primary-menu-active');
	});

}


function µSpacer(factor = 1) {
	let spacer = 32;
	if ( 'CSS' in window && CSS.supports && CSS.supports('(--foo: red)' ) ) {
		spacer = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--spacer-current').slice(0,-2));
	}
	return spacer * factor;
}

function smoothScroll($) {

	$('a[href*=\\#]:not([href=\\#])').click(function(e) {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-(µSpacer(2))
				}, 800);
				e.preventDefault();
			}
		}				
	}); 

}

function sendAjax($, postData, $form, $errorNotice, callback) {

	$errorNotice.addClass('hidden');

	if ( emptyRequiredFields($form) === true ) return;

	$.ajax({
		url: localizedData.adminAjaxUrl,
		type: "POST",
		cache: false,
		data: postData,
		success: function(res) {

			if (callback) callback(res, postData);

			if (res.success != true) {
				console.log(res);
			}
			
		}
	});

	function emptyRequiredFields($form) {
		let emptyFields = false;
		$form.find('input[required]').each(function() { 
			const $this = $(this);
			if ( !$this.val().length ) {
				$this.addClass("required");
				emptyFields = true;
				return;
			}
		});

		$form.find('.js-radio-group').each(function() {
			const $this = $(this);
			const $checkedRadio = $this.find('input[type=radio]:checked');
			if ( !$checkedRadio.length ) {
				console.log('empty radio');
				$this.addClass("required");
				emptyFields = true;
				return;
			}
		});

		return emptyFields;

	} 

}

function subscribeToNewsletter($) {

	const $form = $('#newsletter-form');
	const $email = $form.find('#email-ns');
	const $submitBtn = $form.find('#submit-ns');

	$form.submit(function(e){

		e.preventDefault();

		const email = $email.val();
		$form.addClass('loading');

		$.ajax({
			url: localizedData.adminAjaxUrl,
			type: "POST",
			cache: false,
			data: {
				action: 'register_newsletter',
				email: email,
			},
			success:function(res){
				$form.removeClass('loading');
				if (res.success) {
					$form.addClass('success');
				}
				else {
					$form.addClass('error');
					console.log(res);
				}
			}
		});
	});

}
